import { isAxiosError } from 'axios';
import { inject, injectable } from 'inversify';
import WalletService from 'src/features/pariWallet/data/service/WalletService';
import { GetAvailableCreditsParams } from 'src/features/pariWallet/data/service/WalletService.types';
import {
  AvailableCreditsParsedResponse,
  GetAvailableCreditsUseCaseInterface,
} from 'src/features/pariWallet/domain/WalletUseCases.types';
import { parseToNumberOrNull } from 'src/utils/numbers/parteToNumberOrNull';

@injectable()
class GetAvailableCreditsUseCase
  implements GetAvailableCreditsUseCaseInterface
{
  @inject(WalletService) private walletService!: WalletService;

  async execute({
    userUuid,
    totalOrder,
  }: GetAvailableCreditsParams): Promise<AvailableCreditsParsedResponse> {
    try {
      const response = await this.walletService.getAvailableCredits({
        userUuid,
        totalOrder,
      });

      return {
        total_credits: parseToNumberOrNull(response.data.total_credits),
        available_credits: parseToNumberOrNull(response.data.available_credits),
      };
    } catch (error) {
      if (isAxiosError(error) && error.response?.status === 404) {
        return { total_credits: 0, available_credits: null };
      }
      throw error;
    }
  }
}

export default GetAvailableCreditsUseCase;
